import h from 'hyperscript';
import getVideoId from 'get-video-id';
import initPhotoswipe from '../../../javascripts/utils/photoswipe';

class Figure {
  constructor($el) {
    // Elements
    this.$el = $el;
    this.$media = this.$el.querySelector('.figure__media');
    this.$videoPlay = this.$el.querySelector('.figure__play');

    // Add events
    if (this.$videoPlay) {
      this.$videoPlay.addEventListener('click', this.onVideoClick.bind(this));
    }
  }

  onVideoClick(event) {
    event.preventDefault();

    const { id, service } = getVideoId(this.$videoPlay.href);

    if (id && service === 'youtube') {
      // Construct Youtube iframe player, add rel=0 to disable related videos
      const $iframe = h(
        '.figure__video-wrapper',
        h('iframe.figure__video', {
          src: `https://www.youtube-nocookie.com/embed/${id}?rel=0&autoplay=1`,
          allowFullscreen: true,
          msAllowFullscreen: true,
          webkitAllowFullscreen: true,
          mozAllowFullscreen: true,
        }),
      );

      // Replace with iframe
      this.$videoPlay.parentNode.replaceChild($iframe, this.$videoPlay);
    }
  }

  getMediaType() {
    return this.$el.querySelector('.figure__play') ? 'video' : 'image';
  }
}

document.querySelectorAll('.js-figure').forEach($el => new Figure($el));

// lightbox
function groupByLightboxDataAttribute(element) {
  return element.getAttribute('data-lightbox-group');
}
// init grouped lightbox (elements with common data-lightbox-group attribute)
const groupedObjects = Object.groupBy(document.querySelectorAll('.js-lightbox[data-lightbox-group]'), groupByLightboxDataAttribute);
Object.entries(groupedObjects).forEach(([, entries]) => {
  initPhotoswipe(entries);
});

// init lightbox for all elements without group attribute
initPhotoswipe(Array.prototype.slice.call(document.querySelectorAll('.js-lightbox:not([data-lightbox-group])')));
